var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultCorporation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 9C14 6.79086 15.7909 5 18 5H46C48.2091 5 50 6.79086 50 9V58C50 59.1046 49.1046 60 48 60H16C14.8954 60 14 59.1046 14 58V9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 23C19 22.4477 19.4477 22 20 22H24C24.5523 22 25 22.4477 25 23V30C25 30.5523 24.5523 31 24 31H20C19.4477 31 19 30.5523 19 30V23Z",
    fill: "#D7BDFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 11C19 10.4477 19.4477 10 20 10H24C24.5523 10 25 10.4477 25 11V18C25 18.5523 24.5523 19 24 19H20C19.4477 19 19 18.5523 19 18V11Z",
    fill: "#D7BDFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29 23C29 22.4477 29.4477 22 30 22H34C34.5523 22 35 22.4477 35 23V30C35 30.5523 34.5523 31 34 31H30C29.4477 31 29 30.5523 29 30V23Z",
    fill: "#D7BDFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29 11C29 10.4477 29.4477 10 30 10H34C34.5523 10 35 10.4477 35 11V18C35 18.5523 34.5523 19 34 19H30C29.4477 19 29 18.5523 29 18V11Z",
    fill: "#D7BDFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39 23C39 22.4477 39.4477 22 40 22H44C44.5523 22 45 22.4477 45 23V30C45 30.5523 44.5523 31 44 31H40C39.4477 31 39 30.5523 39 30V23Z",
    fill: "#D7BDFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39 11C39 10.4477 39.4477 10 40 10H44C44.5523 10 45 10.4477 45 11V18C45 18.5523 44.5523 19 44 19H40C39.4477 19 39 18.5523 39 18V11Z",
    fill: "#D7BDFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19 35C19 34.4477 19.4477 34 20 34H24C24.5523 34 25 34.4477 25 35V42C25 42.5523 24.5523 43 24 43H20C19.4477 43 19 42.5523 19 42V35Z",
    fill: "#D7BDFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29 35C29 34.4477 29.4477 34 30 34H34C34.5523 34 35 34.4477 35 35V42C35 42.5523 34.5523 43 34 43H30C29.4477 43 29 42.5523 29 42V35Z",
    fill: "#D7BDFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39 35C39 34.4477 39.4477 34 40 34H44C44.5523 34 45 34.4477 45 35V42C45 42.5523 44.5523 43 44 43H40C39.4477 43 39 42.5523 39 42V35Z",
    fill: "#D7BDFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24 49C24 48.4477 24.4477 48 25 48H39C39.5523 48 40 48.4477 40 49V60H24V49Z",
    fill: "#D7BDFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32 48V60",
    stroke: "#AF7BFF",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultCorporation);
export default __webpack_public_path__ + "static/media/DefaultCorporation.463b69c221d3fe20c9df6aaab2532b31.svg";
export { ForwardRef as ReactComponent };